import { CiShare1 } from "react-icons/ci";
import { Link } from "react-router-dom";
import AdminSwitch from '../../components/CommonComponents/AdminSwitch'
import { FaEllipsisVertical } from "react-icons/fa6";
import MessageBox from "../CommonComponents/MessageBox";
import { IconDelete, IconDeleteFigma, IconEditFigma, IconSolidEdit } from "../../Assets/MyIcons";
import { FaEye } from "react-icons/fa";


//BoostrapTable formatter
const statusFormatter = (cell, row) => {
    return (
        <div className={`d-inline-flex justify-content-center px-3 py-1 text-center ${cell === "PUBLISHED" ? "PUBLISHED_active" : cell === "SCHEDULED" ? " DISABLED_active" : "UNPUBLISHED_active"}`} > {cell} </div>
    );
};
const statusActiveFormatter = (cell, row) => {
    return (
        <div className={`d-inline-flex justify-content-center px-3 py-1 text-center ${cell === "ACTIVE" ? "PUBLISHED_active" : cell === "SCHEDULED" ? " DISABLED_active" : "UNPUBLISHED_active"}`} > {cell} </div>
    );
};
const statusActiveFormatteruser = (cell, row) => {
    return (
        <div className={`d-inline-flex justify-content-center px-3 py-1 text-center ${cell === "Active" ? "ACTIVE_active" : cell === "SCHEDULED" ? " In-Active" : "In-ACTIVE_active"}`} > {cell} </div>
    );
};

const statusActiveFormatterDevices = (cell, row) => {
    // Convert cell to number, expect only 1 or 0
    const isActive = Number(cell) === 1;

    // Apply class based on active status
    const className = isActive ? "ACTIVE_active" : "In-ACTIVE_active";

    // Display "Active" or "Inactive" text instead of raw 1/0
    const displayText = isActive ? "Active" : "In-Active";

    return (
        <div className={`d-inline-flex justify-content-center px-3 py-1 text-center ${className}`}>
            {displayText}
        </div>
    );
};

const videoFormatter = (cell, row, siteTheme, languageCode) => {
    // const isTranslationEnabled = siteTheme?.translate_checkout == 1;
    const slugPath = row.slug || row.artist_slug;
    const pathPrefix = typeof siteTheme === 'string' ? siteTheme : '';
    // const finalLink = isTranslationEnabled
    //     ? `${process.env.REACT_APP_Baseurl_Frontend}/${languageCode}/${slugPath}`
    //     : `${process.env.REACT_APP_Baseurl_Frontend}/${pathPrefix ? pathPrefix + '/' : ''}${slugPath}`;

    const finalLink = `${process.env.REACT_APP_Baseurl_Frontend}/${pathPrefix ? pathPrefix + '/' : ''}${slugPath}`;

    const displayTitle = row.title || row.albumname || row.artist_name || "Unknown";
    const trimmedTitle = `${displayTitle.slice(0, 15)}...`;
    const imageSrc = row.image_url || row.Thumbnail || row.image || row.album;

    return (
        <div className="d-flex justify-content-between align-items-center">
            {imageSrc ? (
                <img
                    src={imageSrc}
                    alt={displayTitle}
                    className="profile theme-bg-color-secondary"
                />
            ) : (
                <div className="profile theme-bg-color-secondary text-dark d-flex align-items-center justify-content-center admin-input-title">
                    {displayTitle.slice(0, 1).toUpperCase()}
                </div>
            )}
            <div className="rightVideoTitle">
                <Link
                    className="theme-text-color table-heading d-flex align-items-center"
                    target="_blank"
                    to={finalLink}
                >
                    <span>{trimmedTitle}</span>
                    <CiShare1
                        style={{ width: "15px", height: "15px", strokeWidth: "1px", marginLeft: "6px" }}
                    />
                </Link>
                {row?.duration !== "0" && (
                    <span className="me-1 dateText theme-text-color table-subheading">
                        {row.duration}
                    </span>
                )}
                <span className="dateText table-subheading theme-text-color">
                    {row.upload_on}
                </span>
            </div>
        </div>
    );
};

const seriesFormatter = (cell, row, siteTheme, languagecode) => {
    return (
        <div className="d-flex justify-content-between align-items-center">
            {row?.album || row?.image_url || row?.Thumbnail || row?.image ? (
                <img
                    key={row?.image_url || row?.album}
                    src={row?.image_url || row?.image || row?.Thumbnail || row?.album}
                    alt={row?.title || row?.albumname || 'Thumbnail'}
                    className="profile theme-bg-color-secondary"
                />
            ) : (
                <div className="profile theme-bg-color-secondary text-dark d-flex align-items-center justify-content-center admin-input-title">
                    {row?.title?.slice(0, 1).toUpperCase()}
                </div>
            )}
            <div className="rightVideoTitle">
                <Link
                    className="theme-text-color table-heading d-flex align-items-center"
                    target="_blank"
                    to={`${process.env.REACT_APP_Baseurl_Frontend}/${siteTheme?.translate_checkout === 1
                        ? `${languagecode}/shows/` : 'shows/'}${row?.slug || row?.artist_slug}`}
                >
                    <span>
                        {`${row?.title?.slice(0, 15) || row?.albumname?.slice(0, 15) || row?.artist_name?.slice(0, 15)}...`}
                    </span>
                    <CiShare1
                        style={{
                            width: "15px",
                            height: "15px",
                            strokeWidth: "1px",
                            marginLeft: "6px",
                        }}
                    />
                </Link>
                {row?.duration !== "0" && (
                    <span className="me-1 dateText theme-text-color table-subheading">
                        {row?.duration}
                    </span>
                )}
                <span className="dateText table-subheading theme-text-color">
                    {row?.upload_on}
                </span>
            </div>
        </div>
    );
};

const videoArtistFormatter = (cell, row, siteTheme, languageCode) => {
    const isTranslationEnabled = siteTheme?.translate_checkout == 1; // use loose comparison
    const slugPath = row.slug ? row.slug : row.artist_slug;
    const finalLink = isTranslationEnabled
        ? `${process.env.REACT_APP_Baseurl_Frontend}/${languageCode}/music/artist/${slugPath}`
        : `${process.env.REACT_APP_Baseurl_Frontend}/music/artist/${slugPath}`;
    const imageSrc = row?.image_url || row?.Thumbnail || row?.image || row?.album;
    const displayTitle = row?.title || row?.albumname || row?.artist_name || "Unknown";
    const trimmedTitle = `${displayTitle.slice(0, 15)}...`;
    return (
        <div className="d-flex justify-content-between align-items-center">
            {imageSrc ? (
                <img key={imageSrc} src={imageSrc} alt={displayTitle} className="profile theme-bg-color-secondary" />
            ) : (
                <div className="profile theme-bg-color-secondary text-dark d-flex align-items-center justify-content-center admin-input-title">
                    {displayTitle.slice(0, 1).toUpperCase()}
                </div>
            )}
            <div className="rightVideoTitle">
                <Link className="theme-text-color table-heading d-flex align-items-center" target="_blank" to={finalLink}  >
                    <span>{trimmedTitle}</span>
                    <CiShare1 style={{ width: "15px", height: "15px", strokeWidth: "1px", marginLeft: "6px", }}
                    />
                </Link>
                {row?.duration !== "0" && (
                    <span className="me-1 dateText theme-text-color table-subheading">
                        {row?.duration}
                    </span>
                )}
                <span className="dateText table-subheading theme-text-color">
                    {row?.upload_on}
                </span>
            </div>
        </div>
    );
};

const ActionFormatterComponent = ({
    cell,
    row,
    link,
    previewlink,
    action,
    hideEditNavigation,
    PreviewNavigation
}) => {
    return (
        <div className="editdropdown">
            <span className="editdropdown-button">
                <FaEllipsisVertical className="theme-text-color" />
            </span>
            <div className="editdropdown-menu theme-bg-color rounded-2 overflow-hidden">
                {/* Edit Option */}
                {!hideEditNavigation && (
                    <Link to={`${link}${row?.id}`} className="theme-text-color theme-bg-color">
                        <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                        <span className="theme-text-color">
                            <MessageBox text="Edit" classname="ms-2 theme-text-color" />
                        </span>
                    </Link>
                )}

                {/* Preview Option */}
                {PreviewNavigation && (
                    <Link to={`${previewlink}`} className="theme-text-color theme-bg-color">
                        <span className="theme-text-color">
                            <FaEye />
                            <MessageBox text="Preview & Edit" classname="ms-2 theme-text-color" />
                        </span>
                    </Link>
                )}

                {/* Delete Option — Hidden for ID = 1 */}
                {row?.id !== 1 && (
                    <div
                        onClick={() => action(row?.id)}
                        className="commonActionPadding theme-bg-color"
                    >
                        <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
                        <MessageBox text="Delete" classname="ms-2 theme-text-color" />
                    </div>
                )}
            </div>
        </div>
    );
};

const ActionFormatterTemplateComponent = ({ cell, row, link }) => {
    return (
        <div className="editdropdown rounded-2 ">
            <span className="editdropdown-button">
                <FaEllipsisVertical className="theme-text-color" />
            </span>
            <div className="editdropdown-menu theme-bg-color rounded-2">
                <Link to={`${link}${row?.id}`} className="theme-text-color  theme-bg-color">
                    <span className="theme-text-color">
                        {/* <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <g>
                                <path class="svgIcon" d="M10.3,18.5l-4.74.64A.49.49,0,0,1,5,18.59l.64-4.74a.42.42,0,0,1,.14-.28L17.31,2a.59.59,0,0,1,.85,0L22.11,6a.6.6,0,0,1,0,.84L10.58,18.36A.53.53,0,0,1,10.3,18.5Z" />
                                <line class="svgIcon" x1="1.01" y1="21.58" x2="18.89" y2="21.58" />
                            </g>
                        </svg> */}
                        <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                        <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
                    </span>
                </Link>
            </div>
        </div>
    );
};


const SliderFormatterComponent = ({ cell, row, action }) => {
    return (
        <div>
            {/* <label className="switch">
                <input
                    name="banner"
                    id="banner"
                    className={`${Number(cell) == 0 ? "inactive" : "active"} ${cell}`}
                    checked={cell == 1}
                    onChange={() => action(row)}
                    onClick={() => action(row)}
                    type="checkbox"
                />
                <span className="slider round"></span>
            </label> */}

            <AdminSwitch
                name="banner"
                id="banner"
                checked={cell == 1}
                onChange={() => action(row)}
                className={`${Number(cell) == 0 ? "inactive" : "active"} ${cell}`}
            />
        </div>
    )
}


export { statusActiveFormatter, ActionFormatterTemplateComponent, statusFormatter, statusActiveFormatteruser, statusActiveFormatterDevices, videoFormatter, ActionFormatterComponent, videoArtistFormatter, SliderFormatterComponent, seriesFormatter }